import { defineFeatures } from "../define-provider-capability";

const mobileDopplerEnv = (name: string) => ({
  name,
  availability: "boot" as const,
  source: {
    kind: "doppler" as const,
    project: "mobile",
    config: "environment" as const,
  },
  mobileEasArtifact: "eas-json" as const,
});

/**
 * The `branch` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const branchMobileFeatures = defineFeatures({
  // Mobile-side Branch SDK init keys. Different namespacing (EXPO_PUBLIC_*)
  // and stored in mobile/<env-instance> Doppler.
  mobile: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [
      mobileDopplerEnv("EXPO_PUBLIC_BRANCH_LIVE_KEY"),
      mobileDopplerEnv("EXPO_PUBLIC_BRANCH_TEST_KEY"),
    ],
  },
});
